module.exports = __webpack_public_path__ + "img/emilia-massa-byn.b83a6b98.jpg";